export default {
  input: {
    fontSize: 18,
  },
  label: {
    fontSizeFocused: 12,
    fontSizeNormal: 18,
  },
  maxWidth: 600,
};
